import { textStyleButton2 } from "common/components/Style/new/textStyle";
import {
  InputContainer,
  InputWrapper,
} from "common/components/Wrapper/InputBase";
import { colors } from "common/const/colors";
import { useValidCheckSingle } from "common/hooks/validCheck";
import styled from "styled-components";

const ToggleGroup = styled(InputContainer)`
  display: flex;
  border: 1px solid var(--Gray);
  border-radius: var(--border-radius-8);
  overflow: hidden;
`;

const ToggleOption = styled.button.attrs({ type: "button" })`
  flex: 1;
  padding: 1rem;
  background-color: ${({ active }) =>
    active ? colors.MainBlue : colors.White};
  color: ${({ active }) => (active ? colors.White : colors.LightNavy)};
  border: none;
  cursor: pointer;

  ${textStyleButton2}

  &:not(:first-child) {
    border-left: 1px solid var(--Gray);
  }

  &:focus {
    background-color: var(--MainBlue);
  }
`;

export const SelectButton = ({
  //InputWrapper
  label,
  caption,

  //SelectButton
  name,
  value,
  defaultValue,
  onChange,
  required,
  disabled,
  options,
}) => {
  const isControlled = value !== undefined && typeof onChange === "function";

  const { inputProps, error, onValueChange } = useValidCheckSingle({
    name: name,
    rules: { required: required || false },
    defaultValue: defaultValue,
  });

  const currentValue = isControlled ? value : inputProps.value;

  const handleSelect = (val) => {
    if (disabled) return;
    onValueChange(val);
    if (onChange) onChange(val);
  };

  return (
    <InputWrapper
      label={label}
      caption={caption}
      rules={{ required }}
      error={error}>
      <ToggleGroup>
        {options.map((option) => (
          <ToggleOption
            key={option.value}
            active={option.value === currentValue}
            onClick={() => handleSelect(option.value)}
            disabled={disabled}>
            {option.text}
          </ToggleOption>
        ))}
      </ToggleGroup>
    </InputWrapper>
  );
};
